import { all, fork } from 'redux-saga/effects';

import listenLoad from './listenLoad';
import listenRemoveDriver from './listenRemoveDriver';
import listenSendInvite from './listenSendInvite';

export default function* additionalDriversSaga() {
  yield all([fork(listenLoad), fork(listenSendInvite), fork(listenRemoveDriver)]);
}
